import React, { useState } from 'react';
import axios from 'axios';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Grid, Box, Typography, Button, Snackbar, Alert } from '@mui/material';
import { LearnersProfile } from '../../../../../../helper/base_url';

const Resume = () => {
    const [resumeFile, setResumeFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file && file.size > 50 * 1024) {
            setMessage({ type: 'error', text: 'Resume exceeds the 50KB limit.' });
            setOpenSnackbar(true);
            setTimeout(() => setMessage({ type: '', text: '' }), 4000);
            return;
        }

        if (file) {
            setResumeFile(file);
            // setMessage({ type: 'success', text: 'Resume selected successfully.' });
            //setOpenSnackbar(true);
            setTimeout(() => setMessage({ type: '', text: '' }), 4000);
        }
    };

    const uploadResume = async () => {
        if (!resumeFile) {
            setMessage({ type: 'error', text: 'Please select a resume file first.' });
            setOpenSnackbar(true);
            setTimeout(() => setMessage({ type: '', text: '' }), 4000);
            return;
        }

        const formData = new FormData();
        formData.append("resumeFile", resumeFile);

        try {
            setUploading(true);
            const token = localStorage.getItem("token");

            await axios.put(
                `${LearnersProfile}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setMessage({ type: 'success', text: 'Resume uploaded successfully.' });
            setOpenSnackbar(true);
        } catch (err) {
            //console.error(err);
            setMessage({ type: 'error', text: 'Failed to upload resume.' });
            setOpenSnackbar(true);
        } finally {
            setUploading(false);
            setTimeout(() => setMessage({ type: '', text: '' }), 4000);
        }
    };

    return (
        <>
            <Grid container spacing={3} justifyContent="center" marginBottom={8}>
                <Grid item xs={12} md={14}>
                    <Box
                        sx={{
                            p: 4,
                            borderRadius: 3,
                            boxShadow: 3,
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <Typography variant="h5" fontWeight={600} gutterBottom color="#052659">
                            Upload Your Resume
                        </Typography>
                        <Typography variant="body1" color="textSecondary" mb={2}>
                            Please upload your resume in PDF, DOC, or DOCX format. Max size: 50KB.
                        </Typography>

                        <Box mt={3} display="flex" alignItems="center" gap={2}>
                            <input
                                accept=".pdf,.doc,.docx"
                                id="upload-resume"
                                type="file"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            <label htmlFor="upload-resume">
                                <Button
                                    variant="contained"
                                    component="span"
                                    startIcon={<UploadFileIcon />}
                                    sx={{
                                        backgroundColor: '#052659',
                                        color: '#fff',
                                        textTransform: 'none',
                                        px: 3,
                                        py: 1.5,
                                        '&:hover': {
                                            backgroundColor: '#043885',
                                        },
                                    }}
                                >
                                    Choose File
                                </Button>
                            </label>

                            {resumeFile && (
                                <Typography variant="body2" sx={{ color: '#555' }}>
                                    📄 {resumeFile.name}
                                </Typography>
                            )}
                        </Box>

                        <Button
                            variant="contained"
                            onClick={uploadResume}
                            disabled={!resumeFile || uploading}
                            sx={{
                                marginTop : 3,
                                padding: '10px 20px',
                                fontWeight: 600,
                                backgroundColor: '#052659',
                                '&:hover': {
                                    backgroundColor: '#043885',
                                },
                            }}
                        >
                            Save Resume
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            {/* Snackbar for messages */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity={message.type === 'error' ? 'error' : 'success'}
                    sx={{ width : '100%' }}
                >
                    {message.text}
                </Alert>
            </Snackbar>
        </>
    );
};

export default Resume;
